import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import WindowIcon from '@mui/icons-material/Window';
import Box from '@mui/material/Box';
import React, { useCallback, useMemo } from 'react';

import { ViewTypesEnum } from '../../../../types/shell';

import ViewSwitchButton from './ViewSwitchButton';

interface IProps {
  activeView: ViewTypesEnum;
  setActiveView: (view: ViewTypesEnum) => void;
}

export const ViewSwitcher: React.FC<IProps> = ({ activeView, setActiveView }) => {
  const isListActive = useMemo(() => activeView === ViewTypesEnum.List, [activeView]);
  const isGridActive = useMemo(() => activeView === ViewTypesEnum.Grid, [activeView]);

  const getColor = useCallback((isActive: boolean) => (isActive ? 'action' : 'disabled'), []);
  const getBorderStyle = useCallback(
    (isActive: boolean) => `1px solid ${isActive ? 'rgba(0, 0, 0, 0.12)' : 'transparent'}`,
    [],
  );

  return (
    <Box sx={{ display: 'flex', marginRight: 0.5 }}>
      <ViewSwitchButton
        isActive={isListActive}
        onClick={() => setActiveView(ViewTypesEnum.List)}
        icon={<FormatListBulletedIcon sx={{ width: 24, height: 24 }} color={getColor(isListActive)} />}
        borderRadius="4px 0 0 4px"
        borderStyle={getBorderStyle(isListActive)}
        dataAction="list_view"
      />
      <ViewSwitchButton
        isActive={isGridActive}
        onClick={() => setActiveView(ViewTypesEnum.Grid)}
        icon={<WindowIcon sx={{ width: 24, height: 24 }} color={getColor(isGridActive)} />}
        borderRadius="0 4px 4px 0"
        borderStyle={getBorderStyle(isGridActive)}
        dataAction="grid_view"
      />
    </Box>
  );
};
